export default __webpack_public_path__ + "static/media/age.f12c1a07.svg";